import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-649c9702")
const _hoisted_1 = { class: "editor-body" }
const _hoisted_2 = { class: "editor-content" }
const _hoisted_3 = { style: {"border":"1px solid #ccc","width":"100%"} }
const _hoisted_4 = { class: "functionArea" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

import { onBeforeUnmount, ref, shallowRef, onMounted, computed } from 'vue'
import { Editor } from '@wangeditor/editor-for-vue'
import {
  getCoursewareInfo
} from '@/services/courseware'
import '@wangeditor/editor/dist/css/style.css' // 引入 css


export default {
  props: {
  readOnly: {
    type: Boolean,
    default: true
  },
  content: {
    type: Object,
    default: null
  },
  id: Number
},
  emits: ['onSave'],
  setup(__props, { emit: emits }) {

const props = __props


const getIdValue = computed(() => props.content)
console.log(getIdValue.value)


// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 内容 HTML
const valueHtml = ref('')

const previewValue = () => {
  valueHtml.value = getIdValue.value.plan_content
}
previewValue()

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

const handleSave = () => {
  emits('onSave', valueHtml.value)
}

const handleCreated = (editor) => {
  editorRef.value = editor // 记录 editor 实例，重要！
  // 设置只读
  if (props.readOnly) {
    editor.disable()
  }
}

return (_ctx, _cache) => {
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Editor), {
          style: {"height":"300px","overflow-y":"hidden"},
          modelValue: valueHtml.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (valueHtml.value = $event)),
          defaultConfig: _ctx.editorConfig,
          mode: _ctx.mode,
          onOnCreated: handleCreated
        }, null, 8, ["modelValue", "defaultConfig", "mode"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_a_button, {
          type: "primary",
          size: "large",
          onClick: handleSave
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 512), [
          [_vShow, !__props.readOnly]
        ])
      ])
    ])
  ]))
}
}

}